import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { accountingAccessRoles } from './access';

const accountingRoles = { roles: [...accountingAccessRoles] } as const;

export const accountingRoutes: RouteObject[] = [
  {
    path: 'zoho-sync',
    async lazy() {
      const { ZohoSyncLayout } = await import('./layouts/ZohoSyncLayout');
      return { Component: ZohoSyncLayout };
    },
    handle: defineHandle({
      ...accountingRoles,
      breadcrumb: 'breadcrumb.zohoSync',
      title: 'common:nav.zohoSync',
    }),
    children: [
      {
        index: true,
        async lazy() {
          const { ZohoSyncOverviewPage } = await import('./pages/ZohoSyncOverviewPage');
          return { Component: ZohoSyncOverviewPage };
        },
        handle: defineHandle({
          ...accountingRoles,
          breadcrumb: 'breadcrumb.zohoSyncOverview',
          title: 'common:nav.zohoSyncOverview',
        }),
      },
      {
        path: 'products',
        async lazy() {
          const { ProductSyncPage } = await import('./pages/ProductSyncPage');
          return { Component: ProductSyncPage };
        },
        handle: defineHandle({
          ...accountingRoles,
          breadcrumb: 'breadcrumb.zohoSyncProducts',
          title: 'common:nav.zohoSyncProducts',
        }),
      },
      {
        path: 'jobs',
        async lazy() {
          const { SyncJobsPage } = await import('./pages/SyncJobsPage');
          return { Component: SyncJobsPage };
        },
        handle: defineHandle({
          ...accountingRoles,
          breadcrumb: 'breadcrumb.zohoSyncJobs',
          title: 'common:nav.zohoSyncJobs',
        }),
      },
      {
        path: 'dead-letters',
        async lazy() {
          const { DeadLettersPage } = await import('./pages/DeadLettersPage');
          return { Component: DeadLettersPage };
        },
        handle: defineHandle({
          ...accountingRoles,
          breadcrumb: 'breadcrumb.zohoSyncDeadLetters',
          title: 'common:nav.zohoSyncDeadLetters',
        }),
      },
      {
        path: 'payment-accounts',
        async lazy() {
          const { PaymentMethodMapsPage } = await import('./pages/PaymentMethodMapsPage');
          return { Component: PaymentMethodMapsPage };
        },
        handle: defineHandle({
          ...accountingRoles,
          breadcrumb: 'breadcrumb.zohoSyncPaymentAccounts',
          title: 'common:nav.zohoSyncPaymentAccounts',
        }),
      },
      {
        path: 'coa',
        async lazy() {
          const { ChartOfAccountsToolsPage } = await import('./pages/ChartOfAccountsToolsPage');
          return { Component: ChartOfAccountsToolsPage };
        },
        handle: defineHandle({
          ...accountingRoles,
          breadcrumb: 'breadcrumb.zohoSyncCoa',
          title: 'common:nav.zohoSyncCoa',
        }),
      },
    ],
  },
];
